module.exports = __webpack_public_path__ + "img/ic-member-manager.00abd3e0.svg";